import React from "react"

export default (props) => {
    const {color} = props;
    const closePopup = () => {
        $("#alertPopup").hide();
    }

    return(
        <div className="blacklayer-container" id="listPopup" style={{zIndex:"50"}}>
            <div className="bl-blind"></div>
            <div className="in-layerarea">
                {/* <div className="blgrn-box vertical"> */}
                <div className={color ? "blgrn-box vertical priv" : "blgrn-box vertical"}>
                    <div className="doctor-message">
                        <div className="message-box" id="msg">
                            <span>증상시점</span>
                            <span>증상여부</span>
                            <span>증상내용</span>
                        </div>
                        
                        <div className="btn-area">
                            <a className="btn-round gray" onClick={closePopup}>
                                닫기
                            </a>
                            <a className="btn-round wht">
                                등록
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}